import ClientSession from './ClientSession'
import CredentialsStorage from '../io/CredentialsStorage'
import LegacyCRS from './LegacyCRS'
import WanderCRS from './WanderCRS'
import { APIClient } from '../io/api-client'
import { Config } from '../states/WorldState'
import {
  EventHub,
  EventHubKeepAlive,
  EventHubReconnector
} from '../io/event-hub'

export default class ConfigFactory {
  private readonly apiClient: APIClient
  private readonly config: Config

  constructor (apiClient: APIClient, config: Config) {
    this.apiClient = apiClient
    this.config = config
  }

  createClientSession (): ClientSession {
    const eventHub = this.createEventHub()
    const wanderCRS = this.createWanderCRS()
    const legacyCRS = this.createLegacyCRS(wanderCRS)
    return new ClientSession({
      apiClient: this.apiClient,
      eventHubReconnector: this.createEventHubReconnector(eventHub),
      eventHubKeepAlive: this.createEventHubKeepAlive(eventHub),
      eventHub,
      wanderCRS,
      legacyCRS
    })
  }

  createEventHub (): EventHub {
    return new EventHub(this.config.eventHub.url)
  }

  createEventHubReconnector (eventHub: EventHub): EventHubReconnector {
    return new EventHubReconnector(eventHub, [
      this.config.eventHub.reconnectDelayMin,
      this.config.eventHub.reconnectDelayMax
    ])
  }

  createEventHubKeepAlive (eventHub: EventHub): EventHubKeepAlive {
    return new EventHubKeepAlive(
      eventHub,
      // TODO: let server decide how long to ping instead?
      this.config.eventHub.idlePeriodToPing || 23
    )
  }

  createCredentialsStorage (): CredentialsStorage {
    return new CredentialsStorage()
  }

  createWanderCRS (): WanderCRS {
    // TODO: maybe we should read the level from config?
    return new WanderCRS()
  }

  createLegacyCRS (wanderCRS: WanderCRS): LegacyCRS {
    return new LegacyCRS(wanderCRS)
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/models/ConfigFactory.ts